import React, { useState } from "react";
import HeaderComponent from "@components/common/Header/Header";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import ArrowDown from "@styles/all-images/icons/arrow-down.svg";
import SearchIcon from "@styles/all-images/icons/search.svg";
import ArrowLeftIcon from "@styles/all-images/icons/arrow-left.svg";
import ArrowRightIcon from "@styles/all-images/icons/arrow-right.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down.svg";
import UserIcon from "@styles/all-images/icons/bg-user.svg";

const StaffManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const RolesAndPermissionsData = [
    {
      ClientName: "Client 1",
      CompanyName: "Company 1",
      EmailAddress: "client1@gmail.com",
      ContactNumber: "1234567890",
    },
    {
      ClientName: "Client 2",
      CompanyName: "Company 2",
      EmailAddress: "client2@gmail.com",
      ContactNumber: "1234567890",
    },
    {
      ClientName: "Client 3",
      CompanyName: "Company 3",
      EmailAddress: "client3@gmail.com",
      ContactNumber: "1234567890",
    },
    {
      ClientName: "Client 4",
      CompanyName: "Company 4",
      EmailAddress: "client4@gmail.com",
      ContactNumber: "1234567890",
    },
    {
      ClientName: "Client 5",
      CompanyName: "Company 5",
      EmailAddress: "client5@gmail.com",
      ContactNumber: "1234567890",
    },
  ];

  const filteredData = RolesAndPermissionsData.filter((RolePermission) =>
    Object.values(RolePermission).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const [isRightOpen, setIsRightOpen] = useState(false);
  const [selectedRightValue, setRightSelectedValue] = useState("5");

  const righttoggleDropdown = () => {
    setIsRightOpen(!isRightOpen);
  };

  const righthandleOptionClick = (value: string) => {
    setRightSelectedValue(value);
    setIsRightOpen(false);
  };
  return (
    <div>
      <HeaderComponent />

      {/* Sub Header */}
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/roles-and-permissions">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Roles and Permissions
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px]">
        <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden tw-p-4">
          <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
            <div className="tw-flex tw-items-center tw-gap-4">
              <div>
                <h2 className="font-size-lg tw-font-semibold font-primary-color">
                  Role 1
                </h2>
              </div>
            </div>
            <div className="tw-flex tw-items-center tw-gap-4">
              <div className="tw-flex tw-items-center tw-gap-2">
                <span className="tw-text-sm tw-text-gray-600">
                  Rows per page
                </span>
                <div className="tw-relative">
                  <button
                    className="tw-flex tw-justify-between tw-items-center tw-px-3 tw-py-1 tw-bg-transparent tw-border
                   tw-border-[#E9EAEB] tw-text-[#232323] tw-rounded-lg"
                    onClick={righttoggleDropdown}
                  >
                    <div className="tw-flex tw-items-center">
                      <span className="tw-mr-3 tw-font-semibold tw-text-[#535862]">
                        {selectedRightValue}
                      </span>
                    </div>
                    <div>
                      <img
                        src={ArrowDownIcon}
                        alt="Arrow Down Icon"
                        className={`tw-w-4 tw-h-4 tw-transform ${
                          isRightOpen ? "tw-rotate-180" : "tw-rotate-0"
                        }`}
                      />
                    </div>
                  </button>

                  {isRightOpen && (
                    <div className="tw-absolute tw-right-0 tw-w-auto tw-bg-white tw-rounded-xl tw-shadow-lg tw-border-gray-200 tw-mt-1 tw-p-3">
                      <ul className="tw-py-1">
                        <button
                          className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                          onClick={() => righthandleOptionClick("1")}
                        >
                          5
                        </button>
                        <button
                          className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                          onClick={() => righthandleOptionClick("2")}
                        >
                          10
                        </button>
                        <button
                          className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                          onClick={() => righthandleOptionClick("3")}
                        >
                          15
                        </button>
                        <button
                          className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                          onClick={() => righthandleOptionClick("4")}
                        >
                          20
                        </button>
                        <button
                          className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                          onClick={() => righthandleOptionClick("5")}
                        >
                          25
                        </button>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="tw-relative">
                <input
                  type="text"
                  placeholder="Search"
                  className="tw-pl-10 tw-pr-4 tw-py-2 tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg tw-w-[320px] tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <img
                  src={SearchIcon}
                  alt="Search Icon"
                  className="tw-absolute tw-left-3 tw-top-2.5 tw-h-5 tw-w-5 tw-text-gray-400"
                />
              </div>
            </div>
          </div>

          <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden">
            <table className="tw-w-full">
              <thead>
                <tr className="tw-border-b">
                  <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862] tw-flex tw-items-center tw-gap-1">
                    Client Name{" "}
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </th>
                  <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      Company Name{" "}
                      <img
                        src={ArrowDown}
                        alt="Arrow Down"
                        className="tw-w-5 tw-h-5"
                      />
                    </div>
                  </th>
                  <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      Email Address{" "}
                      <img
                        src={ArrowDown}
                        alt="Arrow Down"
                        className="tw-w-5 tw-h-5"
                      />
                    </div>
                  </th>
                  <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                    Contact Number
                  </th>
                </tr>
              </thead>
              <tbody className="tw-divide-y tw-divide-gray-200">
                {currentData.map((RolePermission, index) => (
                  <tr key={index} className="tw-hover:bg-gray-50">
                    <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <img src={UserIcon} alt="User Icon" />
                        <span>{RolePermission.ClientName}</span>
                      </div>
                    </td>
                    <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                      {RolePermission.CompanyName}
                    </td>
                    <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                      {RolePermission.EmailAddress}
                    </td>
                    <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                      {RolePermission.ContactNumber}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tw-flex tw-justify-between tw-items-center tw-mt-4">
            <div className="tw-text-sm font-gray-color">
              Page {currentPage} of {totalPages}
            </div>
            <div className="tw-flex tw-items-center tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg">
              <button
                className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tl-lg tw-rounded-bl-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                <img
                  src={ArrowLeftIcon}
                  alt="Arrow Left Icon"
                  className="tw-w-5 tw-h-5"
                />
                Previous
              </button>
              <span className="tw-bg-[#EDF3F7] tw-px-3 tw-py-1">
                {currentPage}
              </span>
              <button
                className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tr-lg tw-rounded-br-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
                <img
                  src={ArrowRightIcon}
                  alt="Arrow Right Icon"
                  className="tw-w-5 tw-h-5"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffManagement;
